import React, { useCallback, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import LogDrawer from '@components/Drawers/LogDrawer/LogDrawer';
import moment from 'moment-timezone';
import CanvasTimeSeriesChart from '@components/Charts/CanvasTimeSeriesChart/CanvasTimeSeriesChart';
import { getStackedBarChartMax } from '@helpers';
import { NoDataAvailable } from '@components/Display';

function OperationsPeriodicOverviewChart({ unitTitle, loading, categories, series }) {
  const [logInfo, setLogInfo] = useState(null);
  const chartRef = useRef();

  const handleLogClick = useCallback(
    (date) => {
      setLogInfo({ startDate: moment.utc(parseInt(date)), unit: 'day' });
    },
    [categories]
  );
  // A stacked bar is the sum of every series at the same x value, so let the
  // shared helper group by x: pairing series[0] with series[1] by index assumed
  // both an aligned and a two-series response, and silently ignored a third
  // series (Propulsion), which would have clipped the axis.
  const stackedMax = series.length ? getStackedBarChartMax(series) : 0;
  const maxStackedValue = Number.isFinite(stackedMax) ? stackedMax : 0;

  if (!loading && NoDataAvailable.hasNoData(series)) {
    return <NoDataAvailable height="360px" />;
  }

  return (
    <>
      <CanvasTimeSeriesChart
        disableHoverLinePlugin
        enableBarHover
        includeTooltipSum
        maxY={maxStackedValue * 1.2}
        stackedBar
        chartRef={chartRef}
        id={'operation-periodic-overview-chart'}
        handleLogClick={handleLogClick}
        height={'360px'}
        unit={unitTitle}
        series={series}
        loading={loading}
      />
      <LogDrawer handleClose={() => setLogInfo(null)} open={!!logInfo} logInfo={logInfo} />
    </>
  );
}

OperationsPeriodicOverviewChart.propTypes = {
  loading: PropTypes.bool,
  unitTitle: PropTypes.string,
  categories: PropTypes.arrayOf(PropTypes.string),
  series: PropTypes.arrayOf(PropTypes.object)
};

OperationsPeriodicOverviewChart.defaultProps = {
  loading: false,
  unitTitle: '',
  categories: [],
  series: []
};

export default OperationsPeriodicOverviewChart;
